import { render, staticRenderFns } from "./portalHome.vue?vue&type=template&id=1d2cadb7&scoped=true&"
import script from "./portalHome.vue?vue&type=script&lang=js&"
export * from "./portalHome.vue?vue&type=script&lang=js&"
import style0 from "./portalHome.vue?vue&type=style&index=0&id=1d2cadb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2cadb7",
  null
  
)

export default component.exports